
export const appConfig = {
  apiBaseUrl: 'https://api.poggioridentesrl.it/api',
    appName: 'Poggio Ridente'
};